import { matchPath } from 'react-router-dom';
import ReceiptGatewayInterface from '../../domain/Receipt/ReceiptGatewayInterface';
import Receipt from '../../domain/Receipt/Receipt';

export default class LocalStorageReceiptGateway implements ReceiptGatewayInterface {
  private explicitFolderId: string | null;

  constructor(folderId?: string | null) {
    this.explicitFolderId = folderId ?? null;
  }

  private static getFolderIdFromUrl(): string | null {
    if (typeof window === 'undefined') return null;
    const match = matchPath<{ dossierId?: string }>(window.location.pathname, {
      path: '/dossier/:dossierId',
    });
    return match?.params?.dossierId ?? null;
  }

  private getFolderId(): string | null {
    return this.explicitFolderId ?? LocalStorageReceiptGateway.getFolderIdFromUrl();
  }

  private getKey(baseKey: string): string {
    const folderId = this.getFolderId();
    return folderId ? `${folderId}_${baseKey}` : baseKey;
  }

  find(): Receipt[]|null {
    const receiptsString = localStorage.getItem(this.getKey('receipts'))

    return (typeof receiptsString === 'string') ? JSON.parse(receiptsString) : null
  }
}
